import { locationsPageQueryOptions } from "api/queries/locations";
import { marketsQueryOptions } from "api/queries/markets";
import type { WarmableQuery } from "routing/warmQueries";
import type { LocationsSearch } from ".";

type QueriesInput = { search: LocationsSearch; proId?: number };

export const locationsQuery = ({ search, proId }: QueriesInput) =>
  locationsPageQueryOptions({ ...search, query: "unmanaged", ...(proId ? { pro_id: proId } : {}) });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [marketsQueryOptions(), locationsQuery(input)];
